import _ from 'underscore';
import { buildPerformanceColumn } from './performance-columns';
import { buildFluctuationColumn } from './fluctuation-columns';
import { formatFuncs } from './shared';

export const ColumnCPA = ({ i18n, helpId = 'Page_CampaignGrids_CPA' }) => buildPerformanceColumn({
  i18n,
  name: 'CPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnPartialConversionCPA = ({ i18n, helpId = 'Page_CampaignGrids_CPA' }) => buildPerformanceColumn({
  i18n,
  name: 'PartialConversionCPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnConversions = ({ i18n, helpId = 'Page_CampaignGrids_Conv' }) => buildPerformanceColumn({
  i18n,
  name: 'Conversions',
  format: formatFuncs.integer,
  helpId,
});

export const ColumnConversionsCredit = ({ i18n, helpId = 'Page_CampaignGrids_Conv' }) => buildPerformanceColumn({
  i18n,
  name: 'ConversionsCredit',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnRevenueOnAdSpend = ({ i18n, helpId = 'Page_CampaignGrids_ReturnAdSpend' }) => buildPerformanceColumn({
  i18n,
  name: 'RevenueOnAdSpend',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAdvertiserReportedRevenue = ({ i18n, helpId = 'Page_CampaignGrids_Revenue' }) => buildPerformanceColumn({
  i18n,
  name: 'AdvertiserReportedRevenue',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnConversionRate = ({ i18n, helpId = 'Page_CampaignGrids_ConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'ConversionRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnPartialConversionRate = ({ i18n, helpId = 'Page_CampaignGrids_ConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'PartialConversionRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAllConversionCPA = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvCPA' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversionCPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnAllPartialConversionCPA = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvCPA' }) => buildPerformanceColumn({
  i18n,
  name: 'AllPartialConversionCPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnAllConversions = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConv' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversions',
  format: formatFuncs.integer,
  helpId,
});

export const ColumnAllConversionsCredit = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConv' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversionsCredit',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnAllConversionRevenueOnAdSpend = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvROAS' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversionRevenueOnAdSpend',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAllConversionAdvertiserReportedRevenue = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRevenue' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversionAdvertiserReportedRevenue',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnAllConversionRate = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'AllConversionRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAllPartialConversionRate = ({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'AllPartialConversionRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnViewThroughConversions = ({ i18n, helpId = 'pop_BA_CampaignGrids_ViewThrough' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversions',
  format: formatFuncs.integer,
  helpId,
});

export const ColumnViewThroughConversionsCredit = ({ i18n, helpId = 'pop_BA_CampaignGrids_ViewThrough' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversionsCredit',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnViewThroughConversionsRevenue = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRevenue' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversionsRevenue',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnViewThroughConversionsCPA = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvCPA' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversionsCPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnViewThroughPartialConversionsCPA = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvCPA' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughPartialConversionsCPA',
  format: formatFuncs.decimal,
  helpId,
});

export const ColumnViewThroughConversionsReturnOnAdSpend = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvReturnOnAdSpend' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversionsReturnOnAdSpend',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnViewThroughConversionsRate = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughConversionsRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnViewThroughPartialConversionsRate = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRate' }) => buildPerformanceColumn({
  i18n,
  name: 'ViewThroughPartialConversionsRate',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnNetRevenue = ({ i18n, helpId, permissions }) => buildPerformanceColumn({
  i18n,
  name: 'NetRevenue',
  format: formatFuncs.decimal,
  permissions,
  helpId,
});

export const ColumnConversionsWithFluctuation = ({ i18n, helpId = 'Page_CampaignGrids_Conv', permissions }) => buildFluctuationColumn({
  i18n,
  name: 'Conversions',
  format: formatFuncs.integer,
  permissions,
  helpId,
});

export const ColumnConversionsCreditWithFluctuation = ({ i18n, helpId = 'Page_CampaignGrids_Conv', permissions }) => buildFluctuationColumn({
  i18n,
  name: 'ConversionsCredit',
  format: formatFuncs.decimal,
  permissions,
  helpId,
});

export const ColumnReturnOnAdSpendColumn = ({ i18n, helpId = 'Page_CampaignGrids_ReturnAdSpend', permissions }) => buildFluctuationColumn({
  i18n,
  name: 'ReturnOnAdSpend',
  format: formatFuncs.percentage,
  permissions,
  helpId,
});

export const ColumnSalesCount = ({ i18n, helpId = 'pop_BA_CampaignGrids_Sale' }) => buildPerformanceColumn({
  i18n,
  name: 'SalesCount',
  format: formatFuncs.integer,
  helpId,
});

export const getConversionColumns = ({
  withFluctuations = false,
  withPartialConversions = false,
} = {}) => _.compact([
  withPartialConversions ? ColumnPartialConversionCPA : ColumnCPA,
  withFluctuations && withPartialConversions && ColumnConversionsCreditWithFluctuation,
  withFluctuations && !withPartialConversions && ColumnConversionsWithFluctuation,
  !withFluctuations && withPartialConversions && ColumnConversionsCredit,
  !withFluctuations && !withPartialConversions && ColumnConversions,
  withPartialConversions ? ColumnPartialConversionRate : ColumnConversionRate,
  ColumnAdvertiserReportedRevenue,
  ColumnRevenueOnAdSpend,
  withPartialConversions ? ColumnAllPartialConversionCPA : ColumnAllConversionCPA,
  withPartialConversions ? ColumnAllConversionsCredit : ColumnAllConversions,
  withPartialConversions ? ColumnAllPartialConversionRate : ColumnAllConversionRate,
  ColumnAllConversionAdvertiserReportedRevenue,
  ColumnAllConversionRevenueOnAdSpend,
]);

export const conversionsColumns = getConversionColumns();
export const conversionsColumnsWithFluctuation = getConversionColumns({ withFluctuations: true });
